import * as React from 'react';
import { createRoot } from 'react-dom/client';
import { ShellWithStore } from './ShellWithStore';
import { Auth } from './Environment/Auth';
import { startLaunchContext } from '@/shared/http';

// Initialize the per-launch correlation context (MS-CV + correlationId) at page
// load so all App Insights telemetry and backend calls share the same root.
startLaunchContext();

// After a deployment, the old hashed JS chunks are replaced. Users with a cached
// index.html will get "Failed to fetch dynamically imported module" when the
// browser tries to load a chunk that no longer exists. Reload once to pick up the
// fresh index.html with the new chunk references.
window.addEventListener('vite:preloadError', (event) => {
    event.preventDefault();
    window.location.reload();
});

const App = React.lazy(() => import('./App'));

const rootElement = document.getElementById('root');
if (!rootElement) {
    throw new Error('Root element not found');
}

createRoot(rootElement).render(
    <ShellWithStore>
        <Auth>
            <React.Suspense fallback={<div role="status" aria-live="polite">Loading...</div>}>
                <App />
            </React.Suspense>
        </Auth>
    </ShellWithStore>,
);
